import React, { useEffect, useRef, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, Button, CardContent, Grid, IconButton, Modal, TextField, Typography } from '@mui/material';
import { ClearOutlined, LockTwoTone } from "@mui/icons-material";
import { FormattedMessage, useIntl } from "react-intl";
import useConfig from "../../../../hooks/useConfig";
import { useDispatch, useSelector } from "../../../../store";
import { closeActivityDay, getAllActivities } from "../../../../store/actions/activites.actions";
import { format } from "date-fns";
import { openSnackbar } from "../../../../store/slices/snackbar";
import MainCard from "../../../../ui-component/cards/common/MainCard";
import AnimateButton from "../../../../ui-component/components/AnimateButton";
import {LoadingButton} from "@mui/lab";

// ==============================|| ACTIVITY HEADER BUTTON ||============================== //

const BodyConsolidate = React.forwardRef(({ modalStyle, handleClose }: any, ref: React.Ref<HTMLDivElement>) => {
    const { company } = useConfig()
    const companyState = useSelector((state) => state.company);
    const dispatch = useDispatch()
    const intl = useIntl()
    const [currentLocation, setCurrentLocation] = useState<string | undefined>('')
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        companyState.company.map((el) => {
            if (el.id == company) {
                setCurrentLocation(el.name)
            }
        })
    })

    const handleCloseDay = async () => {
        setIsLoading(true)
        await dispatch(closeActivityDay(company))
        await dispatch(getAllActivities(format(new Date(), 'yyyyMMdd') + 'D'))
        dispatch(
            openSnackbar({
                open: true,
                message: intl.formatMessage({ id: 'FRM00108' }),
                variant: 'alert',
                alert: {
                    color: 'success'
                },
                close: false
            })
        );
        setIsLoading(false)
        handleClose()
    }

    const [disabled, setDisabled] = useState(true)
    return (
        <div ref={ref} tabIndex={-1}>
            <MainCard
                style={modalStyle}
                sx={{
                    position: 'absolute',
                    width: { xs: 280, lg: 450 },
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)'
                }}
                title="Attenzione"
                content={false}
                secondary={
                    <IconButton
                        color="inherit"
                        style={{ marginLeft: '16px' }}
                        onClick={handleClose}
                    >
                        <ClearOutlined sx={{ fontSize: '1.4rem' }} />
                    </IconButton>
                }
            >
                <CardContent>
                    <Typography variant="body1">Prima di proseguire con il consolidamento, ricorda che:</Typography>
                    <ul>
                        <li style={{ marginBottom: '12px' }}>
                            Riguarderà esclusivamente la sede: <b>{currentLocation}</b>
                        </li>
                        <li style={{ marginBottom: '12px' }}>
                            Genererà una variazione contabile per tutte le attività concluse e non consolidate al
                            momento
                        </li>
                        <li style={{ marginBottom: '12px' }}>
                            Eventuali attività in corso o da confermare non verranno coinvolte nel processo e potrai
                            continuare a gestirle normalmente
                        </li>
                        <li style={{ marginBottom: '12px' }}>
                            I borsellini dei soci coinvolti verranno aggiornati di conseguenza
                        </li>
                        <li style={{ marginBottom: '12px' }}>
                            E' un azione irreversibile
                        </li>
                    </ul>
                    <Typography variant="body2" sx={{ mt: 2 }}>
                        Per proseguire digita "Consolida attività":
                    </Typography>
                    <form style={{ marginTop: '16px' }}>
                        <Grid container spacing={4}>
                            <Grid item xs={12} md={8}>
                                <TextField
                                    fullWidth
                                    id="duration"
                                    name="duration"
                                    size={'small'}
                                    onChange={(value) => {
                                        if (value.target.value == 'Consolida attività') {
                                            setDisabled(false)
                                        } else {
                                            setDisabled(true)
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <AnimateButton>
                                <LoadingButton loading={isLoading}  variant={'contained'} color={'error'} disabled={disabled || isLoading}
                                            onClick={handleCloseDay}>
                                        <FormattedMessage id={'SYS00025'} />
                                    </LoadingButton>
                                </AnimateButton>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </MainCard>
        </div>
    )
});

const ConsolidateSection = () => {

    const theme = useTheme();
    const anchorRef = useRef<any>(null);

    // drawer state
    const [openModalCloseDay, setOpenModalCloseDay] = useState(false);

    return (
        <>
            <Box
                sx={{
                    ml: 2,
                    [theme.breakpoints.down('md')]: {
                        ml: 1
                    }
                }}
            >
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                        border: '1px solid',
                        borderColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.dark,
                        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.dark,
                        color: theme.palette.secondary.light,
                        transition: 'all .2s ease-in-out',
                        '&[aria-controls="menu-list-grow"],&:hover': {
                            borderColor: theme.palette.primary.main,
                            background: theme.palette.primary.main,
                            color: theme.palette.primary.light
                        }
                    }}
                    ref={anchorRef}
                    aria-haspopup="true"
                    onClick={() => setOpenModalCloseDay(true)}
                    color="inherit"
                >
                    <LockTwoTone sx={{ fontSize: '1.2rem' }} />
                </Avatar>
            </Box>
            <Modal open={openModalCloseDay} onClose={() => setOpenModalCloseDay(false)}
                   aria-labelledby="simple-modal-title"
                   aria-describedby="simple-modal-description">
                <BodyConsolidate handleClose={() => setOpenModalCloseDay(false)} />
            </Modal>
        </>
    );
};

export default ConsolidateSection;